import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex-end',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 5,
  },
  button: {
    background: 'linear-gradient(45deg, #3D3B8E 30%, #006494 90%)',
    margin: 10,
    color: 'white',
  },
  cancelButton: {
    background: 'linear-gradient(45deg, #de5250 30%, #FF5E5B 90%)',
    margin: 10,
    color: 'white',
  },
}));
